/* Team K9 guide pages. The page reads fine without this: videos open on YouTube, sections are plain anchors. */
(function () {
  "use strict";
  if (window.__tkhInit) return;
  window.__tkhInit = true;
  /* video: the still becomes the player on tap, so nothing loads from YouTube until asked */
  Array.prototype.slice.call(document.querySelectorAll(".tkh [data-tkh-yt]")).forEach(function (link) {
    link.addEventListener("click", function (event) {
      var id = link.getAttribute("data-tkh-yt");
      if (!/^[\w-]{6,20}$/.test(id)) return;
      event.preventDefault();
      var frame = document.createElement("div");
      frame.className = "tkh-yt-frame";
      var player = document.createElement("iframe");
      player.src = "https://www.youtube-nocookie.com/embed/" + id + "?autoplay=1&rel=0";
      player.title = link.getAttribute("aria-label") || "Video";
      player.allow = "accelerometer; autoplay; encrypted-media; picture-in-picture";
      player.allowFullscreen = true;
      frame.appendChild(player);
      link.parentNode.replaceChild(frame, link);
    });
  });
  /* FAQ search: filters the questions as you type. The box is hidden until this runs, so the page works without it. */
  var box = document.querySelector(".tkh [data-tkh-faq-search-box]");
  var input = document.querySelector(".tkh [data-tkh-faq-search]");
  if (box && input) {
    box.hidden = false;
    var groups = Array.prototype.slice.call(document.querySelectorAll(".tkh [data-tkh-faq-group]"));
    var none = document.querySelector(".tkh [data-tkh-faq-none]");
    input.addEventListener("input", function () {
      var words = input.value.toLowerCase().split(/\s+/).filter(Boolean), shown = 0;
      groups.forEach(function (group) {
        var hits = 0;
        Array.prototype.slice.call(group.querySelectorAll("details")).forEach(function (item) {
          var text = item.textContent.toLowerCase();
          var ok = words.every(function (word) { return text.indexOf(word) > -1; });
          item.hidden = !ok;
          if (ok) hits++;
        });
        group.hidden = !hits;
        shown += hits;
      });
      if (none) none.hidden = shown > 0;
    });
  }
})();

/* copy deterrent (owner, 2026-10-04: "dont let folks copy/click on the pages so it's harder to control c"). Inside the brand
   sections: no text selection, no dragging or right-click menu on pictures and plain text, no copy. Form fields, help answers
   and links keep working (a right-click on a text link still offers "open in new tab"). It deters casual copying; it cannot
   stop someone reading the page source. */
(function () {
  "use strict";
  if (window.__tk9Guard) return;
  window.__tk9Guard = true;
  var ROOT = ".tkb, .tka, .tkh", OK = "input, textarea, select, [contenteditable], .tkh-answer, [data-copy-ok]";
  var el = function (n) { return n && n.nodeType === 1 ? n : n && n.parentElement; };
  var guarded = function (n) { n = el(n); return !!(n && n.closest(ROOT) && !n.closest(OK)); };
  document.addEventListener("contextmenu", function (e) {
    var n = el(e.target);
    if (!guarded(n)) return;
    var media = n.closest("img, video, picture, figure, [class*='-bit'], [class*='-cast'], [class*='-peek']");
    if (media || !n.closest("a[href], button")) e.preventDefault();
  });
  document.addEventListener("dragstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("selectstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("copy", function (e) { var s = window.getSelection && window.getSelection(); if (s && s.rangeCount && guarded(s.anchorNode)) e.preventDefault(); });
})();
